module.exports = __webpack_public_path__ + "img/gb6175.prt.856593d1.jpg";